/* Cart-drawer cross-sell — loaded once, unconditionally, so it survives cart-drawer morphs.
   Uses event delegation + re-inits whenever the cart updates. */
(function () {
  if (window.__hbupInit) return;
  window.__hbupInit = true;

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function q(up, sel) { return up.querySelector(sel); }

  function update(up) {
    var dataEl = q(up, '[data-hbup-variants]'); if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var s1 = q(up, '[data-hbup-opt="1"]'), s2 = q(up, '[data-hbup-opt="2"]');
    var key = (s1 ? s1.value : '') + '|' + (s2 ? s2.value : '');
    var v = data[key]; if (!v) return;
    // Discount is declared by the card, not hardcoded. 0 (or absent) means no offer
    // exists for this pairing, so we show the plain price with no struck-through 'was'.
    var pct = parseFloat(up.dataset.hbupDiscount || '0') || 0;
    // Fixed amount off in cents (e.g. the second Sierra Sling), also declared by the card.
    var off = parseInt(up.dataset.hbupOff || '0', 10) || 0;
    var was = v.price, now = Math.max(0, Math.round(v.price * (1 - pct)) - off), save = was - now;
    var deal = save > 0;
    var nowEl = q(up, '[data-hbup-now]'), wasEl = q(up, '[data-hbup-was]'), saveEl = q(up, '[data-hbup-saveamt]'), imgEl = q(up, '[data-hbup-img]'), btn = q(up, '[data-hbup-add]');
    if (nowEl) nowEl.textContent = money(now);
    if (wasEl) { wasEl.textContent = deal ? money(was) : ''; wasEl.hidden = !deal; }
    if (saveEl) { saveEl.textContent = deal ? 'Save ' + money(save) + (pct > 0 ? ' (' + Math.round(pct * 100) + '%)' : '') : ''; saveEl.hidden = !deal; }
    var badge = q(up, '.hbup__badge'); if (badge) badge.hidden = !deal;
    if (imgEl && v.img) imgEl.src = v.img;
    up.dataset.variant = v.id;
    if (btn && btn.dataset.state !== 'adding') {
      if (v.available) { btn.disabled = false; btn.textContent = 'Add to cart · ' + money(now); }
      else { btn.disabled = true; btn.textContent = 'Sold out'; }
    }
  }
  function updateAll() { document.querySelectorAll('[data-hbup]').forEach(update); }
  window.__hbupUpdate = update;

  document.addEventListener('change', function (e) {
    var up = e.target.closest && e.target.closest('[data-hbup]');
    if (up && e.target.matches('select')) update(up);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hbup-add]'); if (!btn) return;
    var up = btn.closest('[data-hbup]'); var id = up && up.dataset.variant; if (!id) return;
    btn.dataset.state = 'adding'; btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: null, sourceId: 'bed-upsell', data: { source: 'bed-upsell' } } }));
      })
      .catch(function () { btn.dataset.state = ''; btn.disabled = false; btn.textContent = 'Add to cart'; });
  });

  // Re-populate whenever the drawer re-renders (upsell may have just appeared).
  document.addEventListener('cart:update', function () { [150, 400, 800, 1400].forEach(function (t) { setTimeout(updateAll, t); }); });

  // Robust catch-all: whenever the DOM changes (e.g. the cart drawer morphs the upsell in),
  // populate any upsell that hasn't been initialised yet.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      document.querySelectorAll('[data-hbup]').forEach(function (up) { if (!up.dataset.variant) update(up); });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
  else updateAll();
})();
